export default __webpack_public_path__ + "development-3.png";